import React, { useEffect, useState } from "react";

const Table = ({ apiResponse, loading, block, values, filter }) => {
  const [output, setOutput] = useState([]);
  const [quantityData, setQuantityData] = useState([]);

  useEffect(() => {
    updateData();
  }, [apiResponse]);

  useEffect(() => {
    console.log(values.filterInput, values.minInput, values.maxInput);
    filterData();
  }, [values]);

  const updateData = () => {
    const result = apiResponse
      .flatMap((item) =>
        item.filtered_products.map((product) => ({
          name: product["Product Name"],
          price: parseFloat(
            (product["Current Price"] || "")
              .replace(" лв.", "")
              .replace(",", ".")
          ), // Convert price to number
          discount: product["Discount"],
          quantity: product["Quantity"],
          pdfName: item["pdf_name"],
        }))
      )
      .sort((a, b) => a.price - b.price);

    setQuantityData(result);
    setOutput(result);
  };

  const filterData = () => {
    const filterInput = values.filterInput;
    const minInput = values.minInput;
    const maxInput = values.maxInput;
  
    if (filter === "Quantity" && (!filterInput || filterInput.length === 0)) {
      setOutput(quantityData);
      return;
    }
  
    if (filter === "Price" && !minInput && !maxInput) {
      setOutput(quantityData);
      return;
    }
  
    const filteredData = quantityData.filter((item) => {
      if (filter === "Quantity") {
        if (item.quantity.match(/\d+/g)?.[0] == undefined) {
          const incrementvalue = 1;
          const quantityMatch = incrementvalue == filterInput;
          return quantityMatch;
        } else {
          const quantityMatch = item.quantity.match(/\d+/g)?.[0] == filterInput;
          return quantityMatch;
        }
      }
      if (filter === "Price") {
        const minPrice = parseFloat(minInput || 0);
        const maxPrice = parseFloat(maxInput || Infinity);
        const priceMatch = item.price >= minPrice && item.price <= maxPrice;
        return priceMatch;
      }
    });
  
    setOutput(filteredData.length ? filteredData : []);
  };
  

  return (
    <>
      <table className="w-full product-table">
        <thead className="text-white">
          <tr>
            <th scope="col" className="px-2 py-3 bg-transparent">
              PDF Name
            </th>
            <th scope="col" className="px-2 py-3 bg-transparent">
              Product Name
            </th>
            <th scope="col" className="px-2 py-3 bg-transparent">
              Quantity
            </th>
            <th scope="col" className="px-2 py-3 bg-transparent">
              Discount (лв)
            </th>
            <th scope="col" className="px-2 py-3 bg-transparent">
              Current Price (лв)
            </th>
            <th scope="col" className="px-2 py-3 bg-transparent">
              Deadline
            </th>
          </tr>
        </thead>
        <tbody>
          {loading
            ? null
            : output?.map((item, index) => {
                const firstIndexFileName = item.pdfName.split(/[-\s.]/)[0];
                const lastIndexFileName = item.pdfName;
                const dateRegex =
                  /(\d{2}[-.\s](?:\d{2}|януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)[-.\s]\d{4}|\d{8})/gi;
                const matches = lastIndexFileName.match(dateRegex);
                const desiredDate =
                  matches?.[matches.length - 1] ?? "Not Found";

                return (
                  <tr key={index} className="even:text-black">
                    <td className="px-2 py-3">{firstIndexFileName}</td>
                    <td className="px-2 py-3">{item.name}</td>
                    <td className="px-2 py-3">{item.quantity ?? "--"}</td>
                    <td className="px-2 py-3">{item.discount ?? "--"}</td>
                    <td className="px-2 py-3">{item.price ?? "--"}</td>
                    <td className="px-2 py-3">{desiredDate}</td>
                  </tr>
                );
              })}
        </tbody>
      </table>
      {loading
        ? null
        : output.length === 0 &&
          block && (
            <>
              <h1 className="text-black text-center text-3xl w-full">
                Searched Product is Not Available
              </h1>
              <h1 className="text-gray-700 text-center text-xl w-full">
                Try Searching something else
              </h1>
            </>
          )}
      {loading && (
        <div className="w-100 d-flex justify-center">
          <div className="spinner"></div>
        </div>
      )}
    </>
  );
};

export default Table;
